import { Pipe, PipeTransform } from '@angular/core';
import { QuoteDetailItem } from '../../modules/back-office/models/quotedetailresponse-response';
import { AptProductType } from '../enums/apttus/apt-product-type';

@Pipe({
    name: 'filterTechProducts',
    pure: false,
})
export class FilterTechProductsPipe implements PipeTransform {
    transform(items: QuoteDetailItem[]): QuoteDetailItem[] {
        if (!items?.length) {
            return items;
        }

        return items.filter(
            (item) => ![AptProductType.FornituraGas, AptProductType.FornituraLuce].includes(item?.productType),
        );
    }
}
